var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.37 42.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #02808d;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.78,12.37h-3.38c-2.65,0-3.17,1.26-3.17,3.11v4.08h6.33l-.83,6.39h-5.51v16.41h-6.6v-16.41h-5.52v-6.4h5.52v-4.71c0-5.47,3.34-8.45,8.22-8.45,2.34,0,4.35.17,4.94.25v5.71h0ZM40.67,0H1.69C.76,0,0,.76,0,1.69v38.98c0,.94.76,1.69,1.69,1.69h38.98c.94,0,1.69-.76,1.69-1.69V1.69c0-.94-.76-1.69-1.69-1.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookNew);
export default __webpack_public_path__ + "static/media/facebook-new.c4d2ed25491a4d465fc390f521d672a3.svg";
export { ForwardRef as ReactComponent };